// extracted by mini-css-extract-plugin
export default {"container":"ContentWrapper_container__sbDIG"};